"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePeriodInteractor = void 0;
const core_1 = require("@veeam/core");
const isOneDay_1 = require("./helpers/isOneDay");
const formatValue_1 = require("../DatetimeInput/helpers/formatValue");
const DEFAULT_TEXTS = {
    am: 'AM',
    pm: 'PM',
    allTime: 'All Time'
};
class DatePeriodInteractor extends core_1.Interactor {
    constructor(valueModel, listener, config) {
        super();
        this.valueModel = valueModel;
        this.listener = listener;
        this.config = config;
        this.textValueModel = new core_1.Model('');
        this.didDone = (nextValue) => {
            var _a, _b, _c;
            this.valueModel.setValue(nextValue);
            (_a = this.presenter) === null || _a === void 0 ? void 0 : _a.hideMenu();
            (_c = (_b = this.listener) === null || _b === void 0 ? void 0 : _b.onChange) === null || _c === void 0 ? void 0 : _c.call(_b, nextValue);
        };
        this.updateTextValue = () => {
            var _a, _b;
            const value = this.valueModel.getValue();
            const texts = (_b = (_a = this.config).texts) === null || _b === void 0 ? void 0 : _b.call(_a);
            if (!value.length) {
                this.textValueModel.setValue((texts === null || texts === void 0 ? void 0 : texts.allTimeValueText) || DEFAULT_TEXTS.allTime);
                return;
            }
            if (this.config.valueFormatter) {
                this.textValueModel.setValue(this.config.valueFormatter({
                    value,
                    withTime: false,
                    is12Hours: false,
                    texts: DEFAULT_TEXTS
                }));
                return;
            }
            if (value.length === 1 || (0, isOneDay_1.isOneDay)(value[0], value[1])) {
                this.textValueModel.setValue((0, formatValue_1.formatValue)(value[0], false, false, false, DEFAULT_TEXTS));
                return;
            }
            this.textValueModel.setValue(`${(0, formatValue_1.formatValue)(value[0], false, false, false, DEFAULT_TEXTS)} - ${(0, formatValue_1.formatValue)(value[1], false, false, false, DEFAULT_TEXTS)}`);
        };
        this.updateTextValue();
        this.valueModel.asObservable().subscribe(() => {
            this.updateTextValue();
        });
    }
}
exports.DatePeriodInteractor = DatePeriodInteractor;
//# sourceMappingURL=DatePeriodInteractor.js.map